module.exports = __webpack_public_path__ + "static/1076518194.4740fc47.jpg";